import { useFormik, FormikProvider, Field } from 'formik';
import TextInput from './TextInput';
import CancelButton from "./CancelButton";
import SaveButton from "./SaveButton";
import { getDefaultDefendant } from '../../utils/formSchema';
import { generateRandomIds } from '../../utils/helper';
import { DefaultMultiPlaintiffName } from "../../utils/constant";

const defaultDefendant = getDefaultDefendant();

const DefendantModal = ({
    show,
    onClose,
    onSave,
    formik: parentFormik,
    selectedDefendantIndex,
    updateDefendant,
    isformEdit,
    addNewDefendant
}) => {
    const isEditMode = selectedDefendantIndex < parentFormik.values.defendants.length;

    const localFormik = useFormik({
        initialValues: isEditMode
            ? parentFormik.values.defendants[selectedDefendantIndex]
            : defaultDefendant,
        enableReinitialize: true,
        onSubmit: (values) => {
            const updatedDefendants = [...parentFormik.values.defendants];
            const isReplacingDefault = (
                updatedDefendants.length === 1 &&
                updatedDefendants[0]?.personalInfo?.name === DefaultMultiPlaintiffName.DEFAULT_DEFENDANT_Name
            );
            if (isReplacingDefault) {
                values.defendantId = updatedDefendants[0].defendantId;
                updatedDefendants[0] = values;
                addNewDefendant?.(values);
            }
            else if (isEditMode) {
                updatedDefendants[selectedDefendantIndex] = values;
                updateDefendant?.(values); 
            } else {
                values.defendantId = generateRandomIds();
                updatedDefendants.push(values);
                addNewDefendant?.(values); 
            }
            parentFormik.setFieldValue("defendants", updatedDefendants);
            onSave?.();
        },
    });

    if (!show) return null;

    return (
        <FormikProvider value={localFormik}>
            <div className="modal user-modal show d-block" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Defendant Details</h5>
                            <CancelButton isButton={false} onClose={onClose} />
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <Field
                                            name="personalInfo.name"
                                            label="Defendant Name"
                                            component={TextInput}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4">
                                <h2 className="form-title mb-6">Insurance Details</h2>
                                <div className="row">
                                    { [
                                        ["insurance.insuranceName", "Insurance Name"],
                                        ["insurance.claimNumber", "Claim Number"],
                                        ["insurance.adjuster.name", "Adjuster Name"],
                                        ["insurance.adjuster.email", "Adjuster Email"],
                                        ["insurance.adjuster.phoneNumber", "Adjuster Phone Number", true],
                                        ["insurance.adjuster.address", "Adjuster Address"],
                                        ["insurance.adjuster.city", "City"],
                                        ["insurance.adjuster.state", "State"],
                                        ["insurance.adjuster.zip", "Zip"]
                                    ].map(([path, label, isPhone]) => (
                                        <div className="col-md-6" key={path}>
                                            <div className="form-group">
                                                <Field
                                                    name={path}
                                                    label={label}
                                                    component={TextInput}
                                                    isPhoneNumber={isPhone}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <CancelButton isButton={true} onClose={onClose} />
                            <SaveButton type="button" className="btn btn-theme" onSave={localFormik.handleSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        </FormikProvider>
    );
};

export default DefendantModal;